import classNames from "classnames";
import * as React from "react";
import GridView, { type GridViewProps } from "./component";
import { NO_TOOLBAR } from "./lib";

export type TitledGridViewProps<T extends {}, D extends {}, ModalProps = void> = GridViewProps<T, D, ModalProps> & {
  title: any;
};
const TitledGridView = <T extends {}, D extends {}, ModalProps = void>({
  className,
  title,
  toolbar,
  ...props
}: TitledGridViewProps<T, D, ModalProps>) => (
  <GridView
    className={classNames("titled", className)}
    toolbar={{
      ...(toolbar ?? NO_TOOLBAR),
      leftButtons: [<span className="title">{title}</span>, ...(toolbar?.leftButtons || [])]
    }}
    {...props}
  />
);
export default TitledGridView;
